import optionAPI from '@/apis/other/optionAPI';
import commonFn from '@/commons/commonFunction';

import { _ } from 'core-js';
import listConfigDefault from '@/assets/config/listConfigDefault';
const state = {
  sort: {
    listAllTask: null,
    listNeedToDo: null,
    listNeedToApprove: null,
    listAssignedByMe: null,
    listInvolve: null,
    listDone: null,
    listDraft: null,
    listReportOperateByMe: null,
    listReportMyOrg: null,
    listReportPersonality: null,
    listApproveUpdateDeadline: null
  },
  sortDefault: _.cloneDeep(listConfigDefault.sortDefault)
};
const getters = {
  sort(state) {
    return state.sort;
  },
  sortDefault(state) {
    return state.sortDefault;
  },
};
const actions = {
  /**
   * goi api lay du lieu setting
   *
   * @param {L} context
   * @param {*} modeTab
   */
  getSortByTab(context, modeTab) {
    let tabName = commonFn.getTabNameByMode(modeTab);

    let result = context.state.sort[tabName];

    if (!result) {
      optionAPI
        .getDbOptions('sort')
        .then((res) => {
          if (res.OptionValue && res.OptionValue[tabName]) {
            // Nếu tồn tại thì set data cho state
            result = res.OptionValue[tabName];
          }
          else {
            // Nếu chưa có field thì lấy default
            result = context.state.sortDefault[tabName];
          }

          context.commit('setSortByTab', { value: result, tabName });
        })
        .catch((err) => {
          // Nếu chưa có thì lấy default
          result = context.state.sortDefault[tabName];
          context.commit('setSortByTab', { value: result, tabName });
        });
    }
  },
  /**
   * goi mutation set gia trị mac dinh cho state tab
   * @param {*} context
   * @param {*} modeTab
   */
  setDefaultSortByTab(context, modeTab) {
    let tabName = commonFn.getTabNameByMode(modeTab);

    context.commit('setSortByTab', { value: context.state.sortDefault[tabName], tabName });
    context.dispatch('updateSortDb')
  },
  /**
   * goi mutation set gia trị cho state tab
   * @param {*} context
   * @param {*} modeTab
   */
  setSortByTab(context, param) {
    let tabName = commonFn.getTabNameByMode(param.modeTab);
    context.commit('setSortByTab', { value: param.value, tabName });
    context.dispatch('updateSortDb')
  },
  /**
   * Goi api lưu thông tin cột vào db
   * @param {*} context
   */
  updateSortDb(context) {
    optionAPI.updateDbOptions({
      model: {
        optionKey: 'sort',
        optionValueType: 3,
        optionValue: context.getters.sort,
      },
    });
  },
};
const mutations = {
  /**
   * Set lai state
   * @param {*} state
   * @param {*} param
   */
  setSortByTab(state, param) {
    state.sort[param.tabName] = param.value;
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
